module.exports = __webpack_public_path__ + "static/media/image-anak-5.67c83300.png";